import {
  Api,
  ApiResponse,
  processApiResponse,
  ApiResponseFormat,
  getConfig,
} from '@moodys/cre-cpm-client-apis.apis.api-base';
import { Session, Permissions } from './models/response/session';

class AuthOrchestratorApi extends Api {
  // ***** Users *****
  public async getSession(): Promise<ApiResponse<Session>> {
    const response = await this.request.get<ApiResponseFormat<Session>>(
      '/v1/sessions',
      {
        fields: {
          sessions: ['token', 'sub', 'iss', 'user', 'company'].join(','),
        },
      },
      {
        headers: this.getHeaders(),
      }
    );

    return processApiResponse(response);
  }

  public async getPermissions(): Promise<ApiResponse<Permissions>> {
    const response = await this.request.get<ApiResponseFormat<Permissions>>(
      '/v1/permissions',
      {
        fields: {
          permissions: [
            'feature_access',
            'portfolio_access',
            'entitlements',
          ].join(','),
        },
      },
      {
        headers: this.getHeaders(),
      }
    );
    return processApiResponse(response);
  }
}

export const authOrchestratorApi = new AuthOrchestratorApi(
  getConfig({ url: process.env.REACT_APP_AUTH_ORCHESTRATOR_API_BASE })
);

export { AuthOrchestratorApi };
